import { TTournamentDetailed } from '@smartico/public-api/dist/SmarticoLib'
import { TournamentRegistrationType } from './enums/TournamentRegistrationType'

export default class Utils {
	private static isMobileCached: boolean = false

	public static isTablet(): boolean {
		// Using screen dimensions to estimate if it's a tablet
		return window.innerWidth / window.innerHeight > 0.65 ? true : false
	}

	public static isMobile(): boolean {
		if (!this.isMobileCached) {
			this.isMobileCached = this.isMobileClean()
		}
		return this.isMobileCached
	}

	public static isLandscape(): boolean {
		return window.matchMedia('(orientation: landscape)').matches
	}

	public static isMobileClean(): boolean {
		// Detect if the device is mobile using the user agent and if its in orientation landscape

		const ua = navigator.userAgent
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)

		return isMobile
	}

	public static adjustItems<T>(items: T[], itemsPerContainer: number) {
		const res = []
		const containers = Math.ceil(items?.length / itemsPerContainer)

		for (let i = 0; i < containers; i++) {
			const start = i * itemsPerContainer
			const end = itemsPerContainer + start
			res.push(items.slice(start, end))
		}

		return res
	}

	public static getRandomNumber(): number {
		const min = 20
		const max = 100
		const random = Math.random() * (max - min) + min 
		return parseFloat(random.toFixed(2)) 
	}
	// public static loadScript(src: string): Promise<void> {
	// 	return new Promise((resolve, reject) => {
	// 		const script = document.createElement('script')
	// 		script.src = src
	// 		script.async = true
	// 		script.onload = () => resolve()
	// 		script.onerror = () => reject(new Error(`Failed to load script ${src}`))
	// 		document.head.appendChild(script)
	// 	})
	// }

	// public static useReactPath(): string {
	// 	const [path, setPath] = React.useState(window.location.pathname)
	// 	const listenToPopstate = () => {
	// 		const winPath = window.location.pathname
	// 		setPath(winPath)
	// 	}
	// 	React.useEffect(() => {
	// 		window.addEventListener('popstate', listenToPopstate)
	// 		return () => {
	// 			window.removeEventListener('popstate', listenToPopstate)
	// 		}
	// 	}, [])
	// 	return path
	// }

	public static formatTournamentBuyIn = (tournament:TTournamentDetailed, short = false): string | null => {
		if (tournament && tournament.registration_type) {
			let s: string | null = null;
			if (tournament.custom_price_text && tournament.registration_type !== TournamentRegistrationType.BUY_IN_POINTS && tournament.registration_type !== TournamentRegistrationType.BUY_IN_GEMS && tournament.registration_type !== TournamentRegistrationType.BUY_IN_DIAMONDS) {
				return tournament.custom_price_text;
			} else {
				switch (tournament.registration_type) {
					case TournamentRegistrationType.AUTO:
					case TournamentRegistrationType.OPT_IN:
					case TournamentRegistrationType.MANUAL_APPROVAL:
						s = "free";
						break;
				case TournamentRegistrationType.BUY_IN_POINTS:
					s = tournament.registration_cost_points?.toString() ?? null;
					break;
				case TournamentRegistrationType.BUY_IN_GEMS:
					s = tournament.registration_cost_gems?.toString() ?? null;
					break;
				case TournamentRegistrationType.BUY_IN_DIAMONDS:
					s = tournament.registration_cost_diamonds?.toString() ?? null;
					break;
				}
				if (short && s) {
					return s;
				} else {
					return s ;
				}
			}
		}
		return null;
	};
}
